const styles = (theme) => ({
  title: {
    marginBottom: theme.spacing(2),
  },
  barcodeBox: {
    marginTop: theme.spacing(2),
    height: 100,
    textAlign: 'center',
  },
  inputForm: {
    marginBottom: theme.spacing(4),
  },
  description: {
    textTransform: 'none',
    marginBottom: theme.spacing(4),
  },
  defaultError: {
    fontSize: 14,
    margin: theme.spacing(0.625, 0, 3.75),
    color: theme.color.red,
  },
  widgetConfigurationsHeader: {
    marginBottom: theme.spacing(3),
    marginTop: theme.spacing(3),
    textAlign: 'center',
  },

  widgetConfigurationsRow: {
    marginTop: theme.spacing(3),
  },

  widgetConfigurationsRowStatus: {
    margin: theme.spacing(0, 3, 0, 1),
    width: theme.spacing(3),
    textAlign: 'center',
    color: theme.color.black_80,
    opacity: 1,
  },
});

export default styles;
